import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/UI/Button';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LoadingIndicator from '../LoadingIndicator';


const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noMoreItems: {
    color: theme.palette.grey[400],
  },
});

const LoadMoreButton = ({
  classes,
  className,
  hasMoreItems,
  loadMoreItems,
  loading,
  LoadingIndicatorComponent,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      {!hasMoreItems && (
        <Typography
          className={classes.noMoreItems}
          color={'primary'}
        >
          {'No more items'}
        </Typography>
      )}
      {loading && <LoadingIndicatorComponent />}
      {!loading && hasMoreItems && (
        <Button
          color="primary"
          onClick={loadMoreItems}
        >
          <ExpandMoreIcon color={'inherit'} />
          {'Load More'}
        </Button>)
      }
    </div>
  );
};

LoadMoreButton.defaultProps = {
  className: '',
  LoadingIndicatorComponent: LoadingIndicator,
};

LoadMoreButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  hasMoreItems: PropTypes.bool.isRequired,
  loadMoreItems: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  LoadingIndicatorComponent: PropTypes.node,
};

export default withStyles(styles)(LoadMoreButton);
